import { Carousel } from "react-bootstrap";
import "aos/dist/aos.css";
import { useEffect } from "react";
import AOS from "aos";

import edificio1 from "../../../assets/images/edifi2.jpg";
import edificio2 from "../../../assets/images/edifi1.jpg";
import edificio3 from "../../../assets/images/edifi7.jpg";
import edificio4 from "../../../assets/images/edifi2.jpg";

function Sedes() {
  useEffect(() => { AOS.init({ duration: 1000 }); }, []);

  return (
    <div className=" "  >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100px", // Ajustá la altura según tu diseño
          backgroundColor: "#1e392e", // opcional, para distinguir el fondo
        }}
      >
        <h4 style={{ fontSize: "3rem", textAlign: "center", color: "white" }}>
          Instalaciones Edilicias
        </h4>
      </div>
    
    

      <div className="p-3 p-md-4 rounded-4 shadow-lg" data-aos="fade-up">
        <Carousel fade interval={4000} className="mx-auto rounded overflow-hidden" style={{ maxWidth: "100%", maxHeight: "600px" }}>
          {slides.map((slide, idx) => (
            <Carousel.Item key={idx}>
              <img className="d-block w-100 img-fluid rounded" src={slide.image} alt={slide.alt} style={{ objectFit: "cover", maxHeight: "500px" }} />

              <Carousel.Caption className="d-none d-md-block">
                <h5 className="fw-bold text-white bg-dark bg-opacity-50 px-3 py-1 rounded-3 d-inline-block text-shadow">{slide.title}</h5>
                <p className="bg-dark bg-opacity-50 px-2 py-1 rounded-3 d-inline-block text-shadow small">{slide.description}</p>
              </Carousel.Caption>

              <Carousel.Caption className="d-block d-md-none">
                <div className="bg-dark bg-opacity-75 px-3 py-2 rounded-3">
                  <h6 className="text-white mb-1">{slide.title}</h6>
                  <small className="text-white">{slide.description}</small>
                </div>
              </Carousel.Caption>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </div>
  );
}

const slides = [
  { image: edificio1, title: "Ingreso Principal - Nivel Inicial", description: "Un entorno acogedor que recibe cada día a los más pequeños con seguridad y alegría.", alt: "Nivel Inicial" },
  { image: edificio2, title: "Espacios Abiertos", description: "Áreas recreativas y de encuentro, ideales para el juego y el compañerismo.", alt: "Espacios exteriores" },
  { image: edificio3, title: "Aulas del Nivel Primario", description: "Espacios luminosos y cómodos que fomentan el aprendizaje colaborativo y creativo.", alt: "Nivel Primario" },
  { image: edificio4, title: "Salones del Nivel Secundario", description: "Ambientes diseñados para el desarrollo intelectual, crítico y tecnológico.", alt: "Nivel Secundario" },
];

export default Sedes;